module.exports = __webpack_public_path__ + "static/media/galeryAbout9.547a5cb5.jpg";